import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation,Outlet  } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import Usuarios from "./pages/Usuarios";
import Alumnos from "./pages/Alumnos";
import Grados from "./pages/Grados";
import Materias from "./pages/Materias";
import Notas from "./pages/Notas";
import NotasPorAlumno from "./pages/NotasxAlumno";
import Actividades from "./pages/Actividades";
import ResultadosActividades from "./pages/ResultadosActividades";
import Login from "./components/Login";

const AppContent = () => {
    const location = useLocation();
    const isAuth = localStorage.getItem("auth"); // Verifica si el usuario está autenticado

    return (
        <>
            <div className="d-flex flex-column min-vh-100">
                {isAuth && location.pathname !== "/login" && <Navbar/>}
                <Routes>
                    <Route path="/login" element={<Login/>}/>

                    {/* Aquí puedes agregar los roles a las rutas protegidas */}
                    <Route path="/" element={<ProtectedRoute
                        allowedRoles={["admin", "maestro", "padre", "alumno"]}><Home/></ProtectedRoute>}/>
                    <Route path="/usuarios"
                           element={<ProtectedRoute allowedRoles={["admin"]}><Usuarios/></ProtectedRoute>}/>
                    <Route path="/alumnos"
                           element={<ProtectedRoute allowedRoles={["admin", "maestro"]}><Alumnos/></ProtectedRoute>}/>
                    <Route path="/grados"
                           element={<ProtectedRoute allowedRoles={["admin"]}><Grados/></ProtectedRoute>}/>
                    <Route path="/materias"
                           element={<ProtectedRoute allowedRoles={["admin"]}><Materias/></ProtectedRoute>}/>
                    <Route path="/notas" element={<ProtectedRoute
                        allowedRoles={["admin", "maestro", "padre"]}><Notas/></ProtectedRoute>}/>
                    <Route path="/notasxAlumno" element={<ProtectedRoute
                        allowedRoles={["admin", "maestro", "padre"]}><NotasPorAlumno/></ProtectedRoute>}/>
                    <Route path="/actividades"
                           element={<ProtectedRoute
                               allowedRoles={["admin", "maestro"]}><Actividades/></ProtectedRoute>}/>
                    <Route path="/resultadosActividades" element={<ProtectedRoute
                        allowedRoles={["admin", "maestro", "padre"]}><ResultadosActividades/></ProtectedRoute>}/>
                </Routes>
                <div className="container flex-grow-1 mt-3">
                    <Outlet/> {/* Aquí se renderizan las páginas */}
                </div>
                {isAuth && location.pathname !== "/login" && <Footer/>}
            </div>

        </>
    );
};

const App = () => (
    <Router>
        <AppContent/>
    </Router>
);

export default App;
